import { useMixpanel } from '@/hooks/use-mixpanel';
import { Flex, Icon, Kbd, Tooltip } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useLocation } from 'react-use';
import { UniversalSearch } from '@/components/universal-search';
import { Search } from '@/assets/icons/nav-v2';
import { KText } from 'ui-library/components';

export const NavSearch = ({ isCollapsed, icon, ...restProps }) => {
  const [isSearchOpen, setSearchOpen] = useState(false);
  const { pathname } = useLocation();
  const { track } = useMixpanel();

  //To close the universal search modal when path changes
  useEffect(() => {
    setSearchOpen(false);
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  useHotkeys(
    'mod+k',
    () => {
      track({
        event: 'global-search',
        prop: {
          type: 'shortcut',
        },
      });
      setSearchOpen((prev) => !prev);
    },
    { enableOnTags: ['INPUT', 'SELECT', 'TEXTAREA'] }
  );

  return (
    <>
      <Tooltip
        label={
          isCollapsed
            ? `Search ${
                navigator.platform.indexOf('Mac') !== -1 ? '(⌘+K)' : ''
              }`
            : ''
        }
        arrowSize={8}
        hasArrow
        placement="right"
        borderRadius="4px"
        variant="default"
      >
        <Flex
          mt="16px"
          bg={isCollapsed ? '#FFF' : 'secondary-100'}
          boxShadow={isCollapsed ? 'none' : 'drop-shadows-bottom'}
          borderRadius="6px"
          p="6px 10px"
          alignItems="center"
          height="39px"
          cursor="pointer"
          _hover={{ bg: '#F4F4F5' }}
          onClick={() => {
            setSearchOpen(true);
            track({
              event: 'global-search',
              prop: {
                type: 'icon-click',
              },
            });
          }}
          {...restProps}
        >
          <Icon
            as={Search}
            color="primary-900"
            width="18px"
            height="18px"
            ml="2px"
            mr="10px"
          />
          {!isCollapsed && (
            <>
              <KText flex="1" color="secondary-500">
                Search
              </KText>
              {navigator.platform.indexOf('Mac') !== -1 && (
                <Flex color="primary-900" fontSize="16px" lineHeight="26px">
                  <Kbd
                    border="0"
                    bg="secondary-100"
                    borderRadius="3px"
                    width="5px"
                    height="24px"
                    display="inline-flex"
                    fontSize="22px"
                    color="primary-900"
                    alignItems="center"
                    justifyContent="center"
                  >
                    ⌘
                  </Kbd>
                  <Kbd
                    border="0"
                    bg="secondary-100"
                    borderRadius="3px"
                    display="inline-flex"
                    width="24px"
                    height="24px"
                    fontSize="14px"
                    color="primary-900"
                    alignItems="center"
                    justifyContent="center"
                  >
                    K
                  </Kbd>
                </Flex>
              )}
            </>
          )}
        </Flex>
      </Tooltip>
      {isSearchOpen && (
        <UniversalSearch
          isOpen={isSearchOpen}
          onClose={() => setSearchOpen(false)}
        />
      )}
    </>
  );
};
